// extracted by mini-css-extract-plugin
export default {"container":"Menu_container__eTjx3","navegador":"Menu_navegador__rfB40","tituloPagamento":"Menu_tituloPagamento__hPEXW"};